import { Injectable } from '@angular/core';
import { ToastService } from '../toast/toast.service';
import { QueovalDate, QueovalDateTime } from '../models';


@Injectable({
  providedIn: 'root'
})

export class QueovalDateService {

  constructor(
    private toast: ToastService = new ToastService()
  ) { }


  public Now(): QueovalDate {
    const annee: string = new Date().getFullYear().toString();
    const mois: string = (new Date().getMonth() + 1).toString();
    const jour: string = new Date().getDate().toString();
    return new QueovalDate(annee, mois, jour);
  }

  /**
   * Vérifie que le jour, le mois, ou l'année soit égale à '0'
   * @param qDate QueovalDate d'origine
   * @returns boolean
   */
  public IsNull(qDate: QueovalDate): boolean {
    return !qDate || !qDate.annee || qDate.annee === '0' || !qDate.mois || qDate.mois === '0' || !qDate.jour || qDate.jour === '0';
  }
  /**
   * Transforme une QueovalDate en string avec un format spécifique pour les inputs date ou le sql
   * @param qDate QueovalDate d'origine
   * @param format default 'yyyy-MM-dd' dispo : 'dd/MM/yyyy', yyyy-dd-MM
   * @returns string
   */
  public ToString(qDate: QueovalDate, format = 'yyyy-MM-dd'): string {
    if (!qDate || (qDate.annee === '0' || qDate.mois === '0' || qDate.jour === '0')) {
      return '';
    } else {
      const strYear: string = Number(qDate.annee) < 10 ? `000${qDate.annee}` : Number(qDate.annee) < 100 ? `00${qDate.annee}` : Number(qDate.annee) < 1000 ? `0${qDate.annee}` : qDate.annee;
      const strDay: string = Number(qDate.jour) < 10 ? `0${Number(qDate.jour)}` : qDate.jour;
      const strMonth: string = Number(qDate.mois) < 10 ? `0${Number(qDate.mois)}` : qDate.mois;
      switch (format) {
        case 'dd/MM/yyyy':
          return `${strDay}/${strMonth}/${strYear}`;
        case 'yyyy-MM-dd':
          return `${strYear}-${strMonth}-${strDay}`;
        case 'yyyy-dd-MM':
          return `${strYear}-${strDay}-${strMonth}`;
        default:
          console.warn(`le format de date '${format}' est inconnu. Format par défaut 'yyyy-MM-dd' utilisé`);
          return `${strYear}-${strMonth}-${strDay}`;
      }
    }
  }

  /**
 * Transforme un date string en QueovalDate
 * @param strDate tout format fonctionnant avec un new Date(strDate)
 */
  public FromString(strDate: string, format = ''): QueovalDate {
    if (!strDate) {
      return new QueovalDate();
    } else {


      let splitedDate: string[];
      switch (format) {
        case 'dd/MM/yyyy':
          splitedDate = strDate.split('/');
          strDate = `${splitedDate[2].length == 1 ? `${0}splitedDate[2]` : splitedDate[2]}-${splitedDate[1].length == 1 ? `${0}splitedDate[1]` : splitedDate[1]}-${splitedDate[0]}`
          break;
        case 'yyyy-dd-MM':
          splitedDate = strDate.split('-');
          strDate = `${splitedDate[0]}-${splitedDate[2].length == 1 ? `${0}splitedDate[2]` : splitedDate[2]}-${splitedDate[1].length == 1 ? `${0}splitedDate[1]` : splitedDate[1]}`
          break;

      }

      let date: Date = new Date(strDate);
      var userTimezoneOffset = date.getTimezoneOffset() * 60000;
      date = new Date(date.getTime() + userTimezoneOffset);
      if (Object.prototype.toString.call(date) === '[object Date]') {
        // it is a date
        if (isNaN(date.getTime())) {
          return new QueovalDate();
        } else {
          const annee: string = String(date.getFullYear());
          const mois: string = String(date.getMonth() + 1);
          const jour: string = String(date.getDate());
          return new QueovalDate(annee, mois, jour);
        }
      } else {
        console.error(`${strDate} n'est pas un format de date valide.`);
        return new QueovalDate();
      }
    }
  }

  /**
   * Transforme un date string en QueovalDate en changeant 00yy-mm-dd en 20yy-mm-dd
   * @param strDate tout format fonctionnant avec un new Date(strDate)
   */
  public FromStringInCentury(strDate: string): QueovalDate {
    const qDate: QueovalDate = this.FromString(strDate);
    if (qDate.annee.length === 2) {
      qDate.annee = `20${qDate.annee}`;
    } else if (qDate.annee.length === 1 && qDate.annee !== '0') {
      qDate.annee = `200${qDate.annee}`;
    }
    return qDate;
  }

  /**
   * Transforme une QueovalDate en Date
   * @param qDate QueovalDate d'origine
   * @returns Date | null
   */
  public ToDate(qDate: QueovalDate): Date | null {
    if (qDate.annee === '0' || qDate.mois === '0' || qDate.jour === '0') {
      return null;
    } else {
      const strYear: string = Number(qDate.annee) < 10 ? `000${qDate.annee}` : Number(qDate.annee) < 100 ? `00${qDate.annee}` : Number(qDate.annee) < 1000 ? `0${qDate.annee}` : qDate.annee;
      const strDay: string = Number(qDate.jour) < 10 ? `0${Number(qDate.jour)}` : qDate.jour;
      const strMonth: string = Number(qDate.mois) < 10 ? `0${Number(qDate.mois)}` : qDate.mois;
      const date: Date = new Date(`${strYear}-${strMonth}-${strDay}`);
      var userTimezoneOffset = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() + userTimezoneOffset);
    }
  }

  /**
 * Transforme une QueovalDateTime en Date
 * @param qDateTime QueovalDateTime d'origine
 * @returns Date | null
 */
  public ToDateTime(qDate: QueovalDateTime): Date | null {
    if (qDate.annee === '0' || qDate.mois === '0' || qDate.jour === '0' || qDate.heures === '' || qDate.minutes === '') {
      return null;
    } else {
      const strYear: string = Number(qDate.annee) < 10 ? `000${qDate.annee}` : Number(qDate.annee) < 100 ? `00${qDate.annee}` : Number(qDate.annee) < 1000 ? `0${qDate.annee}` : qDate.annee;
      const strDay: string = Number(qDate.jour) < 10 ? `0${Number(qDate.jour)}` : qDate.jour;
      const strMonth: string = Number(qDate.mois) < 10 ? `0${Number(qDate.mois)}` : qDate.mois;
      const strHour: string = Number(qDate.heures) < 10 ? `0${Number(qDate.heures)}` : qDate.heures;
      const strMinutes: string = Number(qDate.minutes) < 10 ? `0${Number(qDate.minutes)}` : qDate.minutes;

      const date: Date = new Date(`${strYear}-${strMonth}-${strDay}T${strHour}:${strMinutes}`);
      var userTimezoneOffset = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() + userTimezoneOffset);
    }
  }

  /**
   * transforme une Date en QueovalDate
   * @returns QueovalDate
   * @param date date d'origine
   */
  public FromDate(date: Date | null): QueovalDate {
    if (!date) {
      return new QueovalDate();
    } else {
      const annee: string = String(date.getFullYear());
      const mois: string = String(date.getMonth() + 1);
      const jour: string = String(date.getDate());
      return new QueovalDate(annee, mois, jour);
    }
  }
  /**
 * transforme une Date en QueovalDateTime
 * @returns QueovalDate
 * @param date date d'origine
 */
  public FromDateTime(date: Date | null): QueovalDateTime {
    if (!date) {
      return new QueovalDateTime();
    } else {
      const annee: string = String(date.getFullYear());
      const mois: string = String(date.getMonth() + 1);
      const jour: string = String(date.getDate());
      const heures: string = String(date.getHours());
      const minutes: string = String(date.getMinutes());
      return new QueovalDateTime(annee, mois, jour, heures, minutes);
    }
  }


  /**
 * compare deux QueovalDates
 * exemple: qDateService.Compare(dateDebut, '>', dateFin, -1, 'an')
 * exemple: qDateService.Compare(dateDebut, '>', dateFin, -2, 'ans', 1, mois, 3, 'jours')
 * exemple: qDateService.Compare(dateDebut, '>', dateFin, -1, 'jour')
 * @param firstDate date to compare
 * @param symbol '<' ou '>' ou '=' ou '<=' ou '>='
 * @param secondDate compared date affected by the '...args'
 * @param args [num1: number, determinant1: string, num2: number, determinant2,...]
 * numX => number to add to secondDate
 * determinantX => determine if numX is affected to 'jour','jours', 'day',  'days', 'mois', 'month', 'months', 'an', 'ans', 'year' or 'years'
 * ex: 1, 'an' | -2, 'jours' | 3, 'month' | 10, 'Months'
 * @returns boolean
 */
  public Compare(firstDate: QueovalDate, symbol: string, secondDate: QueovalDate, ...args: any[]): boolean {
    // vérifie que les arguments sont bien un multiple de 2
    if (args.length % 2 !== 0) {
      //#region Console Error
      console.error('un nombre est renseigné mais aucun interval pour la comparaison de deux dates avec interval dans QueovalDateService.Compare(firstDate, symbol, ...args) => args: number, string...');
      return false;
      //#endregion
    }
    const date1: Date | null = this.ToDate(new QueovalDate(firstDate.annee, firstDate.mois, firstDate.jour));
    let date2: Date | null = this.ToDate(new QueovalDate(secondDate.annee, secondDate.mois, secondDate.jour));
    //  const _secondDate: QueovalDate = JSON.parse(JSON.stringify(secondDate));

    // boucle sur toutes les paires d'arguments (donc args / 2 )
    for (let i: number = 0; i < args.length / 2; i++) {
      // indexs des args paires
      const numX: number = args[i * 2 + 0];
      // indexs des args impaires
      const determinantX: string = args[i * 2 + 1];

      //#region console error typeof args
      if (typeof numX !== 'number') {
        console.error(`l'un des arguments passé comme paramètre de type number n'est pas un nombre`);
        return false;
      }
      if (typeof determinantX !== 'string') {
        console.error(`l'un des arguments passé comme paramètre de type string n'est pas une string`);
        return false;
      }
      //#endregion
      // date2 = this.ToDate(_secondDate);
      //#region ajout des args sur la seconde date
      if (numX !== 0) {
        switch (determinantX.toLowerCase()) {
          //#region jour
          case 'jour':
          case 'day':
          case 'jours':
          case 'days':
            //#endregion
            if (date2) {
              date2.setDate(date2.getDate() + numX);
            }
            break;
          //#region mois
          case 'mois':
          case 'month':
          case 'months':
            //#endregion
            if (date2) {
              date2.setMonth(date2.getMonth() + numX);
            };
            break;
          //#region annee
          case 'an':
          case 'year':
          case 'ans':
          case 'years':
            //#endregion
            if (date2) {
              date2.setFullYear(date2.getFullYear() + numX);
            };
            break;
          default:
            //#region console Error
            console.error(`le couple '${numX}': number et '${determinantX}': string est incorect pour la comparaison de deux dates avec interval`);
            const arAccepted: string[] = ['jour', 'day', 'jours', 'days', 'mois', 'month', 'months', 'an', 'ans', 'year', 'years'];
            if (!arAccepted.includes(determinantX.toLowerCase())) {
              console.error(`'${determinantX}' ne fait pas parti des valeurs prises en charges: ${arAccepted.toString()}`);
            }
            //#endregion
            return false;
        }
      }
      //#endregion
    }


    //#region controle l'existance des dates
    if (!date1 && !date2) {
      this.toast.showAlertToast('Merci de renseigner les dates');
      return false;
    }
    if (!date1) {
      this.toast.showAlertToast(`une date n'est pas renseignée`);
      return false;
    }
    if (!date2) {
      this.toast.showAlertToast(`une date n'est pas renseignée`);
      return false;
    }
    //#endregion

    //#region compare les dates en fonction du symbole
    switch (symbol) {
      case '<':
        return date1.getTime() < date2.getTime();
      case '<=':
        return date1.getTime() <= date2.getTime();
      case '>':
        return date1.getTime() > date2.getTime();
      case '>=':
        return date1.getTime() >= date2.getTime();
      case '=':
        return date1.getTime() === date2.getTime();
      default:
        console.error('le symbole de comparaison de date renseigné est incorect.');
        return false;
    }
    //#endregion
  }



  public AbbreviationMonth(date: QueovalDate, addDay: boolean): string {
    switch (date.mois) {
      case '1': return addDay ? `${date.jour} janv.` : `janv.`;
      case '2': return addDay ? `${date.jour} févr.` : `févr.`;
      case '3': return addDay ? `${date.jour} mars` : `mars`;
      case '4': return addDay ? `${date.jour} avr.` : `avr.`;
      case '5': return addDay ? `${date.jour} mai` : `mai`;
      case '6': return addDay ? `${date.jour} juin` : `juin`;
      case '7': return addDay ? `${date.jour} juill.` : `juill.`;
      case '8': return addDay ? `${date.jour} août` : `août`;
      case '9': return addDay ? `${date.jour} sept.` : `sept.`;
      case '10': return addDay ? `${date.jour} oct.` : `oct.`;
      case '11': return addDay ? `${date.jour} nov.` : `nov.`;
      case '12': return addDay ? `${date.jour} déc.` : `déc.`;
      default: return "";
    }

  }


}
